import { render, staticRenderFns } from "./prescription-template-form.vue?vue&type=template&id=703f9d32&lang=pug&"
import script from "./prescription-template-form.vue?vue&type=script&lang=ts&"
export * from "./prescription-template-form.vue?vue&type=script&lang=ts&"
import style0 from "./prescription-template-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports